import { getQueryParam } from '@/common/util/getUrlParam';

function parseMultipartFormData(dataString: string): { [key: string]: string } {
    try {
        return JSON.parse(dataString);
    } catch(e) {
        try {
            const result: { [key: string]: string } = {};
            const list = dataString.split('Content-Disposition: form-data; ');
            for (const item of list) {
                if (item.startsWith('name')) {
                    const match = item.match(/name["=][\\:]?["\\]*([^\\"]+)/);
                    const v = item.match(/\\r\\n\\r\\n([\S\s]+)(?=\\r\\n)/);
                    if (match && v) {
                        const key = match[1];
                        const value = v[1] && v[1].split(/\\r\\n/)[0] || '';
                        result[key] = value;
                    }
                }
            }
            return result;
        } catch(e) {
            return {};
        }
    }
}

const getQueryList = (list: Array<string>, data: { [key: string]: string }) => {
    const field = `info:${list.length > 0 ? list[0] : Date.now()}`;
    for (const key of list) {
        if (key === 'appId') {
            return location.pathname.split('/')[1] || `${Date.now()}`;
        }
        // 不额外取值（没有就不对）
        //  || getQueryParam(key)
        const value = process.env.NODE_ENV === 'development' ? decodeURIComponent(data[key] || getQueryParam(key) || getQueryParam(`server_hack_${key}`) || '') :  decodeURIComponent(data[key] || getQueryParam(`server_hack_${key}`) || '');
        if (value) {
            window.sessionStorage.setItem(field, value);
            return decodeURIComponent(value);
        }
    }
    if (list.length > 0) {
        return window.sessionStorage.getItem(field) || '';
    }
    return '';
};

export const getWindowInfo = () => {
    const data = parseMultipartFormData(document.getElementById('clientAppJson')?.innerText || document.getElementById('clientAppJson')?.innerHTML || '');

    window.isShowUpload === undefined ? window.isShowUpload = !!Number(data.isShowUpload) : window.isShowUpload = window.isShowUpload;
    window.isNotAuthModal === undefined ? window.isNotAuthModal = !!Number(data.isNotAuthModal) : window.isNotAuthModal = window.isNotAuthModal;

    const infoFields = [
        'openid',
        'nickname',
        'avatar',
        'clientInfo',
        'clientVersion',
        'osVersion',
        'os',
        'appId',
        'netType',
        'customInfo',
    ] as const;
    infoFields.forEach(key => {
        window[key] = getQueryList([key], data);
        if (String(window[key]).toLocaleLowerCase() === 'unknown') {
            window[key] = '';
        }
    });

};
